import PolicyPage from "./PolicyPage";

export default function RefundPolicy() {
  return (
    <PolicyPage title="Return &amp; refund policy" path="/refund-policy">
      <p>We stand behind every product we sell. If you are not fully satisfied, return your CreatorMic Pro purchase within 30 days for a full refund.</p>
      <h2>How to return</h2>
      <ul>
        <li>Email <a href="mailto:support@creatormicpro.com" className="text-[#0066FF]">support@creatormicpro.com</a> with your order number.</li>
        <li>We will send you a prepaid return label (US orders).</li>
        <li>Ship the item back in its original condition — used items are fine.</li>
        <li>Refunds are processed within 5 business days of receipt.</li>
      </ul>
      <h2>Warranty replacements</h2>
      <p>Every product includes a 2-year manufacturer warranty. If your item fails due to a defect within 24 months of purchase, we will replace it free of charge — no return required.</p>
      <h2>Non-returnable items</h2>
      <ul>
        <li>Windshield foams and consumable accessories (opened and used)</li>
        <li>Items missing serial numbers or clearly abused</li>
      </ul>
    </PolicyPage>
  );
}
